import React from "react";
import { Card, Form, Input, Row, Col, theme } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

interface Props {
  form: any; // Replace with FormInstance when integrating
  isEditing: boolean;
}

const ContactInfoForm: React.FC<Props> = ({ form, isEditing }) => {
  // Get theme token for dark mode compatibility
  const { token } = theme.useToken();
  return (
    <Card
      title={
        <span>
          <MailOutlined style={{ color: token.colorPrimary }} />
          <span style={{ marginLeft: 8 }}>Contact Information</span>
        </span>
      }
      size="small"
      style={{ marginTop: 16, borderRadius: 8 }}
    >
      <Form form={form} layout="vertical" disabled={!isEditing}>
        <Row gutter={24}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Please enter email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ color: token.colorPrimary }} />}
                placeholder="Enter email address"
                style={{ borderRadius: 6 }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[{ required: true, message: "Please enter phone number" }]}
            >
              <Input
                prefix={<PhoneOutlined style={{ color: token.colorSuccess }} />}
                placeholder="Enter phone number"
                style={{ borderRadius: 6 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ContactInfoForm;
